import { render } from "./BuyUnitsExpired.vue?vue&type=template&id=2c88c552"
import script from "./BuyUnitsExpired.vue?vue&type=script&lang=js"
export * from "./BuyUnitsExpired.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__